import React, { useEffect, useRef } from 'react'
import sharedStyles from '../../MultiPage.module.scss'
import styles from './AccountUsers.module.scss'
import { UserF } from '@src/logic/contexts/Users/UsersFrontend.type'
import { mapRoleToReadableRole } from '@src/utils/mapRoleToReadableRole.ts'
import { useModal } from '@logic/contexts/Modal/ModalContext.tsx'
import LxCancelButton from '@src/components/cancelButton/LxCancelButton'
import { Dialog } from '@mui/material'
import LxSaveButton from '@src/components/saveButton/LxSaveButton'

import { USER_STATE } from '@src/utils/constants'
import { LxTooltip } from '@src/components/tooltip/tooltip'
import { UserEdit } from './CreateorEdit/UserEdit.tsx'
import { cn } from '@src/utils/cn'

interface UserInfoProps {
  user: UserF
  onUpdated?: () => void
  accountId: string
  accountName?: string
  canEditUser: boolean
}

const UserInfo: React.FC<UserInfoProps> = ({ user, onUpdated, accountId, accountName, canEditUser }) => {
  const { hideModal, showModal } = useModal()

  const modalRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    // Focus the modal when opens
    modalRef.current?.focus()
  }, [])

  return (
    <Dialog open role='dialog' aria-labelledby='create-user-dialog-title' maxWidth='sm' fullWidth aria-label='User Info'>
      <div className={styles.dialogHeader}>
        <h3>{user.fullName}</h3>
        {accountName && <p className={styles.accountName}>{accountName}</p>}
      </div>
      <div className={styles.dialogContent}>
        <div className={styles.infoRow}>
          <strong>First Name:</strong>
          <span>{user.firstName}</span>
        </div>
        <div className={sharedStyles.infoRow}>
          <strong>Last Name:</strong>
          <span>{user.lastName}</span>
        </div>
        <div className={sharedStyles.infoRow}>
          <strong>Email:</strong>
          <span>{user.primaryEmail}</span>
        </div>
        <div className={sharedStyles.infoRow}>
          <strong>Title:</strong>
          <span>{user.jobTitle}</span>
        </div>
        <div className={sharedStyles.infoRow}>
          <strong>Role:</strong>
          <span>{mapRoleToReadableRole(user.userRole)}</span>
        </div>
      </div>
      <div className={cn(styles.dialogActions, styles.actionsFullWidth)}>
        <LxCancelButton onCancel={hideModal} label='Close' classNames='lxActionButton,lxActionButtonDefaultSize' />

        {canEditUser &&
          (user.state !== USER_STATE.ACTIVE ? (
            <LxTooltip tooltipText={'Info can be edited only when user is active'}>
              <span>
                <LxSaveButton onSubmit={hideModal} label='Edit User Info' classNames='lxActionButton,lxActionButtonFilled,lxActionButtonDefaultSize' />
              </span>
            </LxTooltip>
          ) : (
            <LxSaveButton
              label='Edit User Info'
              classNames='lxActionButton,lxActionButtonFilled,lxActionButtonDefaultSize'
              onSubmit={() =>
                showModal(
                  <UserEdit
                    user={user}
                    accountId={accountId}
                    accountName={accountName}
                    onUpdated={() => {
                      onUpdated?.() // refresh AccountsList
                      hideModal() // close this AccountInfo dialog
                    }}
                  />
                )
              }
            />
          ))}
      </div>
    </Dialog>
  )
}

export default UserInfo
